export const getElementTop: (element: HTMLElement) => number = (element) => {
  let actualTop = element.offsetTop
  let current = element.offsetParent as HTMLElement

  while (current && current.offsetParent) {
    actualTop += current.offsetTop
    current = current.offsetParent as HTMLElement
  }

  return actualTop
}

export const canUseDom = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export const getDocumentScrollTop = () => {
  return document && (document.documentElement.scrollTop || document.body.scrollTop)
}

export const scrollTo = (_targetY: number, callback?: () => void, maxCall?: number) => {
  const currentY = document.documentElement.scrollTop || document.body.scrollTop
  const { clientHeight, scrollHeight } = document.documentElement
  const targetY = Math.max(Math.min(_targetY, scrollHeight - clientHeight), 0)
  const needScrollTop = targetY - currentY
  let _currentY = currentY

  if (maxCall && maxCall <= 0) {
    window.scrollTo(0, _currentY)
    setTimeout(() => {
      callback && callback()
    }, 20)
    return
  }

  setTimeout(() => {
    const dist = Math.ceil(needScrollTop / 10)
    _currentY += dist
    window.scrollTo(0, _currentY)
    if (needScrollTop > 10 || needScrollTop < -10) {
      scrollTo(targetY, callback, maxCall == null ? 100 : maxCall - 1)
    } else {
      window.scrollTo(0, _targetY)
      setTimeout(() => {
        callback && callback()
      }, 20)
    }
  }, 1)
}
